import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-automation',
	path: '/jira/servicedesk/projects/:projectKey/settings/automate',
};
